import React from 'react';
import { Select, SelectProps } from 'antd';
import _isEmpty from 'lodash/isEmpty';
import { RefSelectProps } from 'antd/lib/select';
import classNames from 'classnames';

export type OptionWrapper = {
	id: string | number;
	name: string;
	render?: React.ReactNode;
	dropDownKey?: string;
	disabled?: boolean;
	label?: string;
};

interface Props extends Omit<SelectProps<any>, 'options'> {
	onChange?: (value: any) => void; // this is for not casting value in all the places;
	children?: React.ReactNode;
	options?: OptionWrapper[];
	blockBodyClicks?: boolean;
}

const Option = Select.Option;

const OptGroup = Select.OptGroup;

const getWrapperOptions = (options: OptionWrapper[]) => {
	return options.map(({ id, name, render, dropDownKey, disabled, label }) => (
		<Option
			key={id}
			value={id}
			title={name}
			data-test-id={`${dropDownKey || id}-dropdown-option`}
			data-testid={`${dropDownKey}-dropdown-option`}
			disabled={disabled}
			label={label}
		>
			{render || name}
		</Option>
	));
};

class SelectWrapper extends React.PureComponent<Props> {
	static defaultProps = {
		mode: 'default'
	};

	private selectRef = React.createRef<RefSelectProps>();

	setDropdownIsOpen = (isOpen: boolean) => {
		const className = 'dropdown-is-open';
		if (isOpen) {
			document.body.classList.add(className);
		} else {
			document.body.classList.remove(className);
		}
	};
	componentDidMount() {
		this.setDropdownIsOpen(false);
	}

	render() {
		const { children, options, dropdownClassName, popupClassName, blockBodyClicks, ...selectProps } = this.props;

		const onDropdownVisibleChange = blockBodyClicks ? this.setDropdownIsOpen : null;
		return (
			<div className="select-wrapper">
				{!_isEmpty(options) ? (
					<Select
						ref={this.selectRef}
						popupClassName={classNames(dropdownClassName, popupClassName)}
						onDropdownVisibleChange={onDropdownVisibleChange}
						{...selectProps}
					>
						{getWrapperOptions(options)}
					</Select>
				) : (
					<Select
						ref={this.selectRef}
						popupClassName={classNames(dropdownClassName, popupClassName)}
						onDropdownVisibleChange={onDropdownVisibleChange}
						{...selectProps}
					>
						{children}
					</Select>
				)}
			</div>
		);
	}

	public getSelectRef() {
		return this.selectRef.current;
	}
}

export default SelectWrapper;

export { Option, OptGroup };
